import Banner0 from './banner-0.webp';
import Banner1 from './banner-1.jpg';

function BannerIncidator(props) {
  return (
    <button
      type="button"
      data-bs-target="#bannerIndicators"
      data-bs-slide-to={props.index}
      className={props.active ? 'active' : ''}
      aria-current={props.active}
    />
  );
}

function BannerImage(props) {
  return (
    <div className={'carousel-item ' + (props.active ? 'active' : '')} data-bs-interval="5000">
      <div className="ratio" style={{ '--bs-aspect-ratio': '50%', maxHeight: '360px' } as any}>
        <img className="d-block w-100 h-100 bg-dark cover" alt="" src={props.image} />
      </div>
      <div className="carousel-caption d-none d-lg-block">
        {/* <h5>Banner Header</h5> */}
        {/* <p>Some representative placeholder content for the banner.</p> */}
      </div>
    </div>
  );
}

function Banner() {
  return (
    <div
      id="bannerIndicators"
      className="carousel slide"
      data-bs-ride="carousel"
      style={{ marginTop: '56px' }}
    >
      <div className="carousel-indicators">
        <BannerIncidator index="0" active={true} />
        <BannerIncidator index="1" />
        <BannerIncidator index="2" />
      </div>
      <div className="carousel-inner">
        <BannerImage image={Banner0} active={true} />
        <BannerImage image={Banner1} />
        {/* <BannerImage image={Banner2} /> */}
      </div>
    </div>
  );
}

export default Banner;
